import React from 'react';
import clsx from 'clsx';

const glowVariants = {
  green: 'glass-card-glow-green',
  red: 'glass-card-glow-red',
  blue: 'glass-card-glow-blue',
  none: 'glass-card',
};

export default function Card({
  title,
  subtitle,
  icon: Icon,
  glow = 'none',
  loading = false,
  className = '',
  children,
  onClick,
}) {
  if (loading) {
    return (
      <div className={clsx(glowVariants[glow] || glowVariants.none, 'p-4', className)}>
        <div className="flex items-center gap-2 mb-3">
          <div className="skeleton w-5 h-5 rounded" />
          <div className="skeleton h-4 w-24 rounded" />
        </div>
        <div className="space-y-2">
          <div className="skeleton h-8 w-20 rounded" />
          <div className="skeleton h-3 w-32 rounded" />
        </div>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        glowVariants[glow] || glowVariants.none,
        'p-4 transition-all duration-200',
        onClick && 'cursor-pointer hover:border-text-muted',
        className
      )}
      onClick={onClick}
    >
      {(title || Icon) && (
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            {Icon && <Icon className="w-4 h-4 text-text-muted" />}
            <div>
              {title && (
                <h3 className="text-xs font-medium text-text-muted uppercase tracking-wider">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="text-[10px] text-text-muted">{subtitle}</p>
              )}
            </div>
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
